module.exports = "::ng-deep .numberformat {\n  text-align: right;\n}\n\n.input-wo {\n  width: inherit;\n  vertical-align: inherit;\n  border: 1px solid black;\n  border-radius: 3px;\n}\n\n.top-btn {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  display: inline-block;\n}\n\n.active {\n  background-color: #000;\n  color: #fecc00;\n}\n\n.autocomplete-input {\n  display: inline-block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/waybill/waybill-list/waybill-list.component.scss
// module id = ./src/app/system/waybill/waybill-list/waybill-list.component.scss
// module chunks = main